export enum CustomMapType {
  ArcGis = 'ArcGIS',
  Wmts = 'WMTS',
  Wms = 'WMS',
}
